module.exports = {
  email: "jdineen81294@gmail.com",

  socialMedia: [
    {
      name: "GitHub",
      url: "https://github.com/jacobdineen",
    },
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/jacobdineen/",
    },
    {
      name: "Twitter",
      url: "https://x.com/jakedineenasu",
    },
  ],

  navLinks: [
    {
      name: "About",
      url: "/#about",
    },
    {
      name: "Experience",
      url: "/#experience",
    },
    {
      name: "News",
      url: "/#news",
    },
    {
      name: "Contact",
      url: "/#contact",
    },
  ],

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: "bottom",
    distance: "20px",
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    mobile: false, // Disable ScrollReveal on mobile - causes content to not show
    reset: false,
    useDelay: "always",
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
}
